import ddt from '@wix/da-ddt';
var fakeCache = {};
var fakeCachedUsed = false;
var LocalStorageWrapper = /** @class */ (function () {
    function LocalStorageWrapper() {
    }
    LocalStorageWrapper.prototype.clear = function () {
        try {
            window.localStorage.clear();
        }
        catch (e) {
            ddt.error('localStorage', e);
        }
    };
    LocalStorageWrapper.prototype.setItem = function (key, value) {
        try {
            window.localStorage.setItem(key, value);
        }
        catch (e) {
            fakeCache[key] = value;
            fakeCachedUsed = true;
            ddt.error('localStorage', e);
        }
    };
    LocalStorageWrapper.prototype.getItem = function (key) {
        try {
            if (fakeCachedUsed) {
                return fakeCache[key] || window.localStorage.getItem(key);
            }
            return window.localStorage.getItem(key);
        }
        catch (e) {
            ddt.error('localStorage', e);
            return null;
        }
    };
    LocalStorageWrapper.prototype.key = function (index) {
        try {
            return window.localStorage.key(index);
        }
        catch (e) {
            ddt.error('localStorage', e);
            return null;
        }
    };
    LocalStorageWrapper.prototype.removeItem = function (key) {
        try {
            return window.localStorage.removeItem(key);
        }
        catch (e) {
            ddt.error('localStorage', e);
            return null;
        }
    };
    Object.defineProperty(LocalStorageWrapper.prototype, "length", {
        get: function () {
            return window.localStorage.length;
        },
        enumerable: false,
        configurable: true
    });
    return LocalStorageWrapper;
}());
export default new LocalStorageWrapper();
//# sourceMappingURL=localStorageWrapper.js.map